export default __webpack_public_path__ + "static/media/mana2r.2f43694e.svg";